/** 'default' = Mastercard/Visa: matriz MDR padrão da unidade. */
export const DEFAULT_CARD_BRAND = 'default';

export const EXTRA_CARD_BRANDS = [
  'elo',
  'amex',
  'hipercard',
  'diners',
  'discover',
  'jcb',
  'cabal',
  'banescard',
] as const;

export type ExtraCardBrand = (typeof EXTRA_CARD_BRANDS)[number];
export type CardBrandCode = typeof DEFAULT_CARD_BRAND | ExtraCardBrand;

export const CARD_BRAND_LABELS: Record<CardBrandCode, string> = {
  default: 'Mastercard / Visa',
  elo: 'Elo',
  amex: 'American Express',
  hipercard: 'Hipercard',
  diners: 'Diners Club',
  discover: 'Discover',
  jcb: 'JCB',
  cabal: 'Cabal',
  banescard: 'Banescard',
};

export function isExtraCardBrand(value: unknown): value is ExtraCardBrand {
  return (EXTRA_CARD_BRANDS as readonly string[]).includes(String(value || '').trim().toLowerCase());
}

export function normalizeCardBrand(value: unknown): CardBrandCode {
  const v = String(value || '').trim().toLowerCase();
  return isExtraCardBrand(v) ? v : DEFAULT_CARD_BRAND;
}

export function parseEnabledCardBrands(raw: unknown): ExtraCardBrand[] {
  if (!Array.isArray(raw)) return [];
  const set = new Set(raw.map((x) => String(x || '').trim().toLowerCase()));
  return EXTRA_CARD_BRANDS.filter((b) => set.has(b));
}

/** Opções do seletor no recebimento: padrão primeiro, depois as extras habilitadas. */
export function cardBrandOptions(enabled: ExtraCardBrand[]): CardBrandCode[] {
  return [DEFAULT_CARD_BRAND, ...enabled];
}
